import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { useDevice } from '../../providers/Device';
import { BottomSheet } from '../BottomSheet';
import { GetEditableTableListTID } from './EditableTableList.types';
import { EditableTableListDesktop } from './EditableTableListDesktop';
import { EditableTableListMobile } from './EditableTableListMobile';
import { useEditableTableListDnd } from './hooks/useEditableTableListDnd';
function EditableTableListInner(param, ref) {
    let { rows, columns, getRowId, isRowStatic, disabledRowTooltip, onRemoveRow, onReorder, disableReorder, renderRowFooter, belowEditableSlot, totalSummary, totalSummaryTestId, mobileCard, hideHeaderWhenEmpty, editSheetHeader, renderEditSheetFooter, renderEditSheet, onEditDismiss, registerAddDraftHandler, renderAddDraftSheet, bi, testId } = param;
    const { EditableTableListTestIds } = useMemo(()=>GetEditableTableListTID(testId), [
        testId
    ]);
    const { isMobileDevice } = useDevice();
    const [addDraft, setAddDraft] = useState(null);
    const dnd = useEditableTableListDnd({
        rows,
        getRowId,
        isRowStatic,
        onReorder,
        disableReorder
    });
    const mobileRef = useRef(null);
    const hasAddDraftSheet = renderAddDraftSheet != null;
    useImperativeHandle(ref, ()=>({
            openEditRow: (rowId)=>{
                var _mobileRef_current;
                return (_mobileRef_current = mobileRef.current) === null || _mobileRef_current === void 0 ? void 0 : _mobileRef_current.openEditRow(rowId);
            }
        }));
    useEffect(()=>{
        if (registerAddDraftHandler == null) return undefined;
        if (!isMobileDevice || !hasAddDraftSheet) {
            registerAddDraftHandler(null);
            return ()=>registerAddDraftHandler(null);
        }
        const handler = (item, commit)=>setAddDraft({
                item,
                commit
            });
        registerAddDraftHandler(handler);
        return ()=>registerAddDraftHandler(null);
    }, [
        registerAddDraftHandler,
        isMobileDevice,
        hasAddDraftSheet
    ]);
    const closeAddDraftSheet = ()=>setAddDraft(null);
    if (isMobileDevice) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(EditableTableListMobile, {
                    ref: mobileRef,
                    rows: rows,
                    columns: columns,
                    getRowId: getRowId,
                    disabledRowTooltip: disabledRowTooltip,
                    onRemoveRow: onRemoveRow,
                    renderRowFooter: renderRowFooter,
                    editSheetHeader: editSheetHeader,
                    renderEditSheetFooter: renderEditSheetFooter,
                    renderEditSheet: renderEditSheet,
                    onEditDismiss: onEditDismiss,
                    belowEditableSlot: belowEditableSlot,
                    totalSummary: totalSummary,
                    totalSummaryTestId: totalSummaryTestId,
                    mobileCard: mobileCard,
                    bi: bi,
                    testIds: EditableTableListTestIds,
                    dnd: dnd
                }),
                /*#__PURE__*/ _jsx(BottomSheet, {
                    open: addDraft != null && renderAddDraftSheet != null,
                    onClose: closeAddDraftSheet,
                    fullHeight: false,
                    children: addDraft != null && (renderAddDraftSheet === null || renderAddDraftSheet === void 0 ? void 0 : renderAddDraftSheet(addDraft.item, {
                        commit: addDraft.commit,
                        close: closeAddDraftSheet
                    }))
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx(EditableTableListDesktop, {
        rows: rows,
        columns: columns,
        disabledRowTooltip: disabledRowTooltip,
        onRemoveRow: onRemoveRow,
        renderRowFooter: renderRowFooter,
        belowEditableSlot: belowEditableSlot,
        totalSummary: totalSummary,
        totalSummaryTestId: totalSummaryTestId,
        hideHeaderWhenEmpty: hideHeaderWhenEmpty,
        bi: bi,
        testIds: EditableTableListTestIds,
        dnd: dnd
    });
}
export const EditableTableList = /*#__PURE__*/ forwardRef(EditableTableListInner);
